import Vue from 'vue'
import Router from 'vue-router'
import Store from './store/index'
import Login from './views/Login'
import Home from './views/Home.vue'
import ResumeKPI from './views/kpi/Resume'
import OrderKPI from './views/kpi/Orders'
import StockKPI from './views/kpi/StockDelay'
import CostKPI from './views/kpi/Cost'
import BufferKPI from './views/kpi/Buffer'
import DebriefResume from './views/debrief/Resume'
import DebriefOrders from './views/debrief/Orders'
import DebriefCost from './views/debrief/Cost'
import DebriefStock from './views/debrief/StockDelay'
import DebriefBuffers from './views/debrief/Buffers'


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'resume',
          name: 'Resume',
          component: ResumeKPI,
          meta: { requiresAuth: true }
        },
        {
          path: 'orders',
          name: 'Orders',
          component: OrderKPI,
          meta: { requiresAuth: true }
        },
        {
          path: 'stock-delay',
          name: 'Stock',
          component: StockKPI,
          meta: { requiresAuth: true }
        },
        {
          path: 'cost',
          name: 'Cost',
          component: CostKPI,
          meta: { requiresAuth: true }
        },
        {
          path: 'buffer',
          name: 'Buffer',
          component: BufferKPI,
          meta: { requiresAuth: true }
        },
        {
          path: 'debrief-resume',
          name: 'DebriefResume',
          component: DebriefResume,
          meta: { requiresAuth: true }
        },
        {
          path: 'debrief-orders',
          name: 'DebriefOrders',
          component: DebriefOrders,
          meta: { requiresAuth: true }
        },
        {
          path: 'debrief-stock',
          name: 'DebriefStock',
          component: DebriefStock,
          meta: { requiresAuth: true }
        },
        {
          path: 'debrief-cost',
          name: 'DebriefCost',
          component: DebriefCost,
          meta: { requiresAuth: true }
        },
        {
          path: 'debrief-buffers',
          name: 'DebriefBuffers',
          component: DebriefBuffers,
          meta: { requiresAuth: true }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Store.state.user.auth) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router